import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function ChevronRight({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 6 10" width={size} {...props}>
      <Path
        d="M1 1L5 5L1 9"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </Svg>
  );
});
